import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { APP_NAME } from 'constants/app.constant'
import LOGOSVG from 'assets/svg/icons/mobilelogo.png'
import { useSelector } from 'react-redux'

const Logo = props => {

	const { 
		type, 
		mode, 
		gutter, 
		className,
		imgClass,
		style, 
		logoWidth 
	} = props
	const {domainLogo} = useSelector((state) => state.theme);
	return (
		<div 
			className={classNames('logo', className)} 
			style={
				{
					...style,
					...{width: logoWidth}
				}
			}
		>
			<img 
				className={imgClass} 
				src={domainLogo} 
				alt={`${APP_NAME} logo`}
				style={{height:30}}
			/>
		</div>
	)
}

Logo.defaultProps = {
	mode: 'light',
	type: 'full',
	logoWidth: 'auto'
}

Logo.propTypes = {
	mode: PropTypes.oneOf(['light', 'dark']),
	type: PropTypes.oneOf(['full', 'streamline']),
	gutter: PropTypes.string,
	imgClass: PropTypes.string,
	logoWidth: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
}

export default Logo
